import { render } from "./WhatsAppAssetStatusPanel.vue?vue&type=template&id=58dab549&ts=true"
import script from "./WhatsAppAssetStatusPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./WhatsAppAssetStatusPanel.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/whatsapp-meta/components/WhatsAppAssetStatusPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58dab549"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58dab549', __exports__)) {
    api.reload('58dab549', __exports__)
  }
  
  module.hot.accept("./WhatsAppAssetStatusPanel.vue?vue&type=template&id=58dab549&ts=true", () => {
    api.rerender('58dab549', render)
  })

}


export default __exports__